import * as actions from '../actions';

const initState = {
  project: null,
  error: null,
  loading: false,

  projectFiles: null,
  projectFilesError: null,
  projectFilesLoading: null
}

const projectReducer = (state = initState, action) => {
  switch (action.type) {
    case actions.CREATE_PROJECT_START: {
      return {
        ...initState,
        loading: true
      }
    }
    case actions.CREATE_PROJECT_SUCCESS: {
      return {
        ...initState,
        loading: false,
        project: action.payload
      }
    }
    case actions.CREATE_PROJECT_ERROR: {
      return {
        ...initState,
        loading: false,
        error: action.payload
      }
    }
    case actions.CREATE_PROJECT_RESET: {
      return {
        ...initState
      }
    }


    case actions.GET_PROJECT_FILES_START: {
      return {
        ...initState,
        projectFilesLoading: true
      }
    }
    case actions.GET_PROJECT_FILES_SUCCESS: {
      return {
        ...initState,
        projectFilesLoading: false,
        projectFiles: action.payload
      }
    }
    case actions.GET_PROJECT_FILES_ERROR: {
      return {
        ...initState,
        projectFilesLoading: false,
        projectFilesError: action.payload
      }
    }

    
    default:
      return state

  }

}

export default projectReducer